import { useEffect, useState, useRef } from "react"
import { Content } from "../util/ContentHelper"
import { off, on, trigger } from "../util/EventManager"
import { gsap } from "gsap"

function Infobox() {

  const [content, setContent] = useState<Content | null>(null)
  const isOpen = useRef(false)

  useEffect(() => {
    const showInfobox = (e: CustomEvent) => {
      if (e.detail) {
        setContent(e.detail);
      } else {
        gsap.to('.textframe', { x: -750, onComplete: () => setContent(e.detail) })
      }
    }
    on('showInfobox', showInfobox)
    return () => {
      off('showInfobox', showInfobox)
    }
  }, [])

  useEffect(() => {
    if (content && !isOpen.current) {
      gsap.from('.textframe', { x: -750 })
      isOpen.current = true;
    } else if (!content) {
      isOpen.current = false
    }
  }, [content])

  return (
    <>
      {content &&
        <div className="textframe" id="infoBox">
          <div className="close" id="close">
            <span onClick={() => trigger('showInfobox', null)}>X</span>
          </div>
          <h3 id="infoHeader">{content.header}</h3>
          <div className="trenner"></div>
          <p id="infoText">{content.text}</p>
          <img id="infoImg" src="" />
          <a id="linkButton" href="#" target="_blank" className="button">Mehr Infos</a>
        </div>}
    </>
  )
}

export default Infobox